export default __webpack_public_path__ + "static/media/logo.420d036f.png";